import { IWorkspaceDB } from '@workspace/apiservice/src/interface/db';
import ILanguageDto from '@workspace/apiservice/src/model/LanguageDto.if';
import IMediumDto from '@workspace/apiservice/src/model/MediumDto.if';
import ISiteObjectDto from '@workspace/apiservice/src/model/SiteObjectDto.if';
import { session } from '@workspace/apiservice/src';
import { DataCheckResult } from '../interface';
import { IRouteTourArguments } from './interface';
import { injectLog } from '../../interface/util';

function mediaRequired(siteObject: ISiteObjectDto, language: ILanguageDto, db: IWorkspaceDB): Promise<Array<IMediumDto>> {
    const log = injectLog();
    
    return new Promise(async function(resolve, reject) {
        try {
            let media: IMediumDto[] = [];

            const translation = await siteObject.translation(db, language);

            if ( translation.mediumId ) {
                media.push(await translation.medium(db));
            }

            resolve(media);
        } catch (error) {
            log.error('Failed to map media ' + error);
            reject(error);
        }
    });
}

function NeedsInternet(route: IRouteTourArguments): Promise<boolean> {
    return new Promise(async function(resolve, reject) {
        try {
            const workspace = await session(route.sessionName);

            await workspace.db.open();

            const language = await workspace.db.language().get(route.languageId);
            const tour = await workspace.db.tour().get(route.tourId);

            const tourRelatedSiteObjects = await workspace.db.tourRelatedSiteObject().all();
            const siteObjectIds = tourRelatedSiteObjects.filter(x => x.tourId === tour.id).map(x => x.siteObjectId);

            const allSiteObjects = await Promise.all(siteObjectIds.map(x => workspace.db.siteObject().get(x)));

            const allRequiredMedia = (await Promise.all(allSiteObjects.map(so => mediaRequired(so, language, workspace.db)))).flat();

            const isAllCached = await workspace.media.isAllMediaCached(allRequiredMedia.map(medium => medium.id));

            const needsInternet = !isAllCached;

            workspace.db.close();

            resolve(needsInternet);
        } catch(error) {
            reject(error);
        }
    });
}
function CanLoad(route: IRouteTourArguments): Promise<DataCheckResult> {
    return new Promise(async function(resolve, reject) {
        const needsInternet = await NeedsInternet(route);

        if ( !needsInternet ) { resolve(DataCheckResult.DataAvailableOffline); }
        else { resolve(DataCheckResult.DataNetworkConnectionNeeded); }
    });
}

export default CanLoad
